import heroBackground from '../../images/backgrounds/bg-books.png'

function Hero() {
    return (
        <>
            <section className="hero" id="hero">
                <div className="hero-background">
                    <img src={heroBackground} alt="" />
                </div>
                <div className="hero-content">
                    <h1>Give Your Books a Second Life</h1>
                    <p>
                        Donate your gently used, readable books and help them find new readers. <i>Quick, easy, and meaningful!</i>
                    </p>

                    <div className="hero-buttons">
                        <a href="#contact" className="btn-primary">Donate Books</a>
                    </div>

                    <ul className="hero-highlights">
                        <li>Usable books only — no strict condition requirements</li>
                        <li>Pickup in Bucks County & neighboring counties</li>
                    </ul>
                </div>
            </section>
        </>
    );
}

export default Hero;